export default "__VITE_ASSET__B045TQ11__"